document.querySelectorAll<HTMLElement>('.block-testimonial-media-split').forEach((block) => {
	const sliderEl = block.querySelector<HTMLElement>('.testimonial-slider');
	const mediaEls = block.querySelectorAll<HTMLElement>(
		'.block-testimonial-media-split__media-item'
	);

	if (null !== sliderEl) {
		new (window as Window).Swiper(sliderEl, {
			slidesPerView: 1,
			watchOverflow: true,
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
				duration: 300,
			},
			navigation: {
				nextEl: block.querySelector('.testimonial-pagination__button--next'),
				prevEl: block.querySelector('.testimonial-pagination__button--prev'),
			},
			on: {
				lock() {
					block.classList.add('testimonial-pagination__button--locked');
				},
				unlock() {
					block.classList.remove('testimonial-pagination__button--locked');
				},
				init(swiper: typeof window.Swiper) {
					const activeSlide = swiper.slides[swiper.activeIndex];
					const id = activeSlide.getAttribute('id');
					const matchingMediaEl = Array.from(mediaEls).find((item) => item.id === id);
					if (matchingMediaEl) {
						matchingMediaEl.classList.add('active');
					}
				},
				slideChange(swiper: typeof window.Swiper) {
					mediaEls.forEach((item) => item.classList.remove('active'));

					const activeSlide = swiper.slides[swiper.activeIndex];
					const id = activeSlide.getAttribute('id');
					const matchingMediaEl = Array.from(mediaEls).find((item) => item.id === id);
					if (matchingMediaEl) {
						matchingMediaEl.classList.add('active');
					}
				},
			},
		});
	}
});
